// GENERATED — edit design/tokens/macrotide.tokens.json, then run `python3 tools/design-tokens/generate.py`. Don't hand-edit this file.

/** The identity's colour roles (docs/design/identity.md §3), light and dark, before theme.ts maps them onto
 * Mantine's theme and tokens.css exposes them as CSS custom properties. */
export const colorTokens = {
  light: {
    backgroundDefault: "#f6f3ec",
    surfaceCard: "#ffffff",
    borderDivider: "#e4ded2",
    textPrimary: "#0e1b2c",
    textSecondary: "#55606d",
    actionPrimary: "#0e3a5b",
    actionOnPrimary: "#ffffff",
    stateSuccessText: "#0c7a64",
    stateWarningText: "#8a5300",
    stateWarningBackground: "#fff3dc",
    stateErrorText: "#b3261e",
    stateErrorBackground: "#fde8e6",
    dataProtein: "#0e3a5b",
    dataCarbs: "#14a38b",
    dataFat: "#c98a1c",
    dataFibre: "#7a4e9c",
    dataGoal: "#c98a1c",
    illustrationSky: "#eaf4f7",
    illustrationWaveFront: "#0e3a5b",
    illustrationWaveBack: "#14a38b",
    illustrationIcon: "#0e3a5b",
  },
  dark: {
    backgroundDefault: "#08121d",
    surfaceCard: "#101e2c",
    borderDivider: "#1e3044",
    textPrimary: "#eaf1f7",
    textSecondary: "#9fb0c0",
    actionPrimary: "#5cc8b4",
    actionOnPrimary: "#06201b",
    stateSuccessText: "#5cc8b4",
    stateWarningText: "#f2b84b",
    stateWarningBackground: "#2a2210",
    stateErrorText: "#ff8a80",
    stateErrorBackground: "#331816",
    dataProtein: "#8db8e6",
    dataCarbs: "#5cc8b4",
    dataFat: "#e5b45a",
    dataFibre: "#c3a3e6",
    dataGoal: "#e5b45a",
    illustrationSky: "#0e1f2e",
    illustrationWaveFront: "#3a79a8",
    illustrationWaveBack: "#5cc8b4",
    illustrationIcon: "#5cc8b4",
  },
}

/** The type scale (docs/design/identity.md §4): Manrope for display numbers, headlines and titles; Inter for
 * body, label and caption. Sizes/line-heights are px, matching tokens.css and the generator's source values. */
export const typeTokens = {
    displayNumber: { family: "Manrope", size: 44, lineHeight: 52, weight: 700 },
    headline: { family: "Manrope", size: 28, lineHeight: 36, weight: 600 },
    title: { family: "Manrope", size: 20, lineHeight: 28, weight: 600 },
    body: { family: "Inter", size: 16, lineHeight: 24, weight: 400 },
    label: { family: "Inter", size: 14, lineHeight: 20, weight: 600 },
    caption: { family: "Inter", size: 12, lineHeight: 16, weight: 400 },
}

/** "Pill & lift" (docs/design/identity.md §5), in px. */
export const shapeTokens = {
  card: 24,
  sheet: 32,
  pill: 999,
}

/** The 8-point grid (docs/design/identity.md §11), in px. */
export const spacingTokens = {
  space4: 4,
  space8: 8,
  space12: 12,
  space16: 16,
  space24: 24,
  space32: 32,
  space48: 48,
}

/** "Crisp" (docs/design/identity.md §9). */
export const motionTokens = {
  standardMs: 200,
  fillMs: 320,
  standardEasing: "cubic-bezier(0.3, 0, 0.1, 1)",
}
